import React from "react";

export default function EventCard({
  date,
  time,
  title,
  location,
  price,
  posterImage,
  className = "",
}) {
  return (
    <div
      className={`w-full rounded-xl overflow-hidden shadow-md border bg-white flex flex-col ${className}`}
    >
      {/* Poster (fixed height/aspect ratio) */}
      <div className="h-[200px] bg-gray-200">
        {posterImage ? (
          <img
            src={posterImage}
            alt={title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
            No Image
          </div>
        )}
      </div>

      {/* Details */}
      <div className="p-3 flex flex-col">
        <p className="text-xs text-gray-600 mb-1">
          {date} {time && `, ${time}`}
        </p>
        <h3 className="font-semibold text-base leading-snug mb-1 line-clamp-2">
          {title}
        </h3>
        <p className="text-gray-500 text-xs truncate">{location}</p>
        {price && (
          <p className="text-green-600 font-semibold text-sm mt-2">
            {price} onwards
          </p>
        )}
      </div>
    </div>
  );
}
